function Bio() {
  return (
    <section
      id="bio"
      className="bio-section"
    >
      {/* TITLE */}
      <h2
        style={{
          fontSize: "32px",
          letterSpacing: "1px",
          marginBottom: "20px"
        }}
      >
        About Me
      </h2>

      {/* MAIN BIO TEXT */}
      <p
        style={{
          fontSize: "18px",
          lineHeight: "1.7",
          opacity: 0.9,
          marginBottom: "40px"
        }}
      >
        I am a theatre director, actor, and educator driven by a passion for storytelling and live performance. 
        My work spans classical and contemporary productions while fostering students’ growth in acting techniques, 
        stage movement, and artistic expression.
      </p>

      {/* SUBSECTION */}
      {/* <h3
        style={{
          fontSize: "22px",
          marginBottom: "15px",
          letterSpacing: "0.5px"
        }}
      >
        Teaching Experience
      </h3> */}

      {/* LIST */}
      {/* <ul
        style={{
          listStyle: "none",
          padding: 0,
          fontSize: "16px",
          lineHeight: "1.8",
          opacity: 0.85
        }}
      >
        <li><strong>Theater Instructor</strong> — University Name</li>
        <li><strong>Workshop Leader</strong> – Acting & Movement</li>
        <li><strong>Director</strong> – Student Productions</li>
      </ul> */}
    </section>
  );
}

export default Bio;